import { QuickContact } from 'components/Layout/Header/HeaderBottom/UserMenu/B2b/QuickContact';
import { ManagerType } from 'types/customer';

type QuickContactWrapperProps = {
    type?: 'menu-desktop' | 'menu-mobile' | 'customer-layout';
    manager: ManagerType | null;
    quickContact: string | null;
};

export const QuickContactWrapper: FC<QuickContactWrapperProps> = ({ type, manager, quickContact }) => {
    if ((!manager || (!manager.email && !manager.telephone)) && !quickContact) {
        return null;
    }

    if (type === 'menu-desktop') {
        return (
            <li className="block max-w-[250px] max-w-full border-t border-grayMidDarker first:border-t-0 xl:max-w-[300px] xxl:max-w-[390px]">
                <div className="block bg-white px-4 py-3.5 text-primary">
                    <QuickContact manager={manager} quickContact={quickContact} />
                </div>
            </li>
        );
    }

    if (type === 'menu-mobile') {
        return (
            <div className="relative min-w-[280px] border-b border-gray py-3 pl-14 leading-6 tracking-wider text-primary no-underline hover:no-underline">
                <QuickContact manager={manager} quickContact={quickContact} />
            </div>
        );
    }

    if (type === 'customer-layout') {
        return (
            <li className="px-8 py-4">
                <QuickContact manager={manager} quickContact={quickContact} />
            </li>
        );
    }

    return <QuickContact manager={manager} quickContact={quickContact} />;
};
